import { daysAgoYmd } from '../../../utils/appTimezone';

/** Intervalle de rafraîchissement automatique de la file infirmerie. */
export const NURSE_QUEUE_POLL_MS = 60_000;

/** Fenêtre de chargement API (jours calendaires, fuseau applicatif). */
export const NURSE_QUEUE_LOOKBACK_DAYS = 7;

export function nurseQueueFetchDateFrom() {
  const ymd = daysAgoYmd(NURSE_QUEUE_LOOKBACK_DAYS - 1);
  return `${ymd} 00:00:00`;
}
